import { useFormikContext } from 'formik';
import { AddressSuggestion } from '../../utils/checkoutState';
import { getInitialAddressValues } from '../../utils/address';
import Modal from '../atoms/Modal';
import AddressList from '../molecules/AddressList';

type AddressSuggestionProps = {
  addresses: AddressSuggestion[];
  context: 'shippingAddress' | 'billingAddress';
  onClose: () => void;
};

const AddressSuggestions = ({ addresses, context, onClose }: AddressSuggestionProps) => {
  const { values, setFieldValue, submitForm } = useFormikContext<any>();
  return (
    <Modal>
      <AddressList
        addresses={addresses.map((address, id) => ({ id, ...address }))}
        context={context}
        usage="suggestion"
        onCancel={onClose}
        onSelect={address => {
          onClose();
          setFieldValue(context, { ...values[context], ...getInitialAddressValues(address) });
          submitForm();
        }}
      />
    </Modal>
  );
};

export default AddressSuggestions;
